if (!window.UGCRowSplideInit) {
	window.UGCRowSplideInit = true

	const SELECTOR = "[data-ugc-row-splide]"

	const mountSlider = element => {
		if (element.dataset.ugcRowSplideMounted === "true" || typeof Splide === "undefined") {
			return
		}

		const slidesCount = element.querySelectorAll(".splide__slide").length
		if (!slidesCount) {
			return
		}

		const splide = new Splide(element, {
			type: "slide",
			autoWidth: true,
			gap: "8px",
			perMove: 1,
			pagination: false,
			arrows: false,
			drag: slidesCount > 1,
			snap: true,
			breakpoints: {
				840: {
					gap: "4px"
				}
			}
		})

		splide.mount()
		element.ugcRowSplide = splide
		element.dataset.ugcRowSplideMounted = "true"
	}

	const destroySlider = element => {
		if (!element.ugcRowSplide) {
			return
		}

		element.ugcRowSplide.destroy(true)
		delete element.ugcRowSplide
		element.dataset.ugcRowSplideMounted = "false"
	}

	const init = (root = document) => {
		root.querySelectorAll(SELECTOR).forEach(mountSlider)
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => init())
	} else {
		init()
	}

	document.addEventListener("shopify:section:load", event => {
		init(event.target)
	})

	document.addEventListener("shopify:section:unload", event => {
		event.target.querySelectorAll(SELECTOR).forEach(destroySlider)
	})
}
